import { render } from "./ListFinished.vue?vue&type=template&id=43f08e23"
import script from "./ListFinished.vue?vue&type=script&lang=js"
export * from "./ListFinished.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Meerbouw/Meerbouw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__